import { render, staticRenderFns } from "./addMsgTemp.vue?vue&type=template&id=6bfd3941"
import script from "./addMsgTemp.vue?vue&type=script&lang=js"
export * from "./addMsgTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports